<template>
  <div class="list-wrapper inline-block w-64 h-full align-top whitespace-nowrap">
    <div class="board-list rounded bg-gray-200 flex flex-col max-h-full relative whitespace-normal">
      <div class="list-header px-4 py-3">
        <slot name="header" />
      </div>
      <!-- <div class="list-header px-4 py-3 flex justify-between items-center">
        <h2 class="text-sm font-medium">
          {{ taskStatus }}
        </h2>
        <span
          v-if="meta"
          class="bg-gray-400 text-gray-900 inline-block
          px-2 text-xs font-normal rounded-full"
        >
          {{ meta.total }}
        </span>
      </div> -->
      <div
        class="list-cards flex-auto overflow-y-auto py-2 overflow-x-hidden mx-1 px-1 -mt-2 min-h-0 space-y-2"
      >
        <slot />
        <!-- <template v-if="ids.length">
          <TaskListLine
            v-for="id in ids"
            :key="id"
            :id="id"
            :focus="lastEditedTaskId === id"
            @task:view="$emit('task:view', $event)"
            @task:updated="notifyTaskUpdated"
          />
          <BaseButton
            v-if="isIdle && hasMore"
            primary
            block
          >
            Load more
          </BaseButton>
        </template>

        <template v-else>
          <div class="p-4 italic text-center text-sm my-2">
            No Tasks
          </div>
        </template> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VKanbanBoardList',
};
</script>
